import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=d8510384&scoped=true&"
import script from "./RequestAccess.vue?vue&type=script&lang=js&"
export * from "./RequestAccess.vue?vue&type=script&lang=js&"
import style0 from "./RequestAccess.vue?vue&type=style&index=0&id=d8510384&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8510384",
  null
  
)

export default component.exports